import { Icon } from '@apia/icons';
import { Box, Button, IconButton } from '@apia/theme';

interface ITrace {
  trace: string;
}

const Trace = ({ trace }: ITrace) => {
  const openModal = () => {
    document.dispatchEvent(
      new CustomEvent('openModal', {
        detail: {
          NavBar: (
            <>
              <Button
                variant="outline-sm"
                onClick={() => {
                  void navigator.clipboard.writeText(
                    document.querySelector<HTMLElement>('.TraceModal__content')
                      ?.innerText ?? '',
                  );
                }}
              >
                Copy trace
              </Button>
            </>
          ),
          children: (
            <Box
              dangerouslySetInnerHTML={{
                __html: trace.replaceAll(
                  /\((\w+\.java:\d+)\)/g,
                  '(<strong>$1</strong>)',
                ),
              }}
            />
          ),
          size: 'xxl',
          title: 'Stack trace',
        },
      }),
    );
  };

  return (
    <Box as="code" className="notification__trace">
      <Box as="strong" className="notification__traceLabel">
        <IconButton
          size="IconMd"
          onClick={openModal}
          title="View trace"
          sx={{
            height: '24px',
            width: '24px',
          }}
        >
          <Icon size="iconXs" title="" name="External" />
        </IconButton>
        <IconButton
          size="IconMd"
          title="Copy trace"
          sx={{
            height: '24px',
            width: '24px',
          }}
          onClick={() =>
            void navigator.clipboard.writeText(
              trace.replaceAll(/<br *\/?>/g, '\n'),
            )
          }
        >
          <Icon size="iconXs" title="" name="Copy" />
        </IconButton>
        <Box as="span">Trace:</Box>
      </Box>
      <Box className="notification__traceText">{trace}</Box>
    </Box>
  );
};

export default Trace;
